export default function SectionContact() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <div className="flex items-center justify-center gap-3 mb-8">
          <span className="w-1 h-7 rounded-full bg-secondary-500"></span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            爆料投稿
          </h2>
        </div>

        <div className="bg-gradient-to-br from-background-100 to-background-50 rounded-2xl border border-background-200/60 p-8 md:p-12">
          <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-secondary-100 flex items-center justify-center">
            <i className="ri-mail-send-line text-2xl text-secondary-600"></i>
          </div>
          <p className="text-base md:text-lg text-foreground-700 leading-relaxed max-w-xl mx-auto mb-6">
            你有独家爆料？发现热门话题？欢迎通过以下方式联系我们。
            51吃瓜团队承诺对投稿人信息严格保密，优质内容一经采纳即付稿酬。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#contact"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-secondary-500 text-background-50 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-secondary-600 transition-colors"
            >
              <i className="ri-mail-line"></i>
              发送邮件投稿
            </a>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50 border border-background-300 text-foreground-700 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors"
            >
              <i className="ri-wechat-line"></i>
              微信联系小编
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}